import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Toast, MessageBox, Popup } from 'mint-ui'
import '@/utils/rem'
import 'babel-polyfill'
import Promise from 'es6-promise'
import 'mint-ui/lib/style.css'
import { VueHammer } from 'vue2-hammer'
const VueCookie = require('vue-cookie')
import vuePicturePreview from 'vue-picture-preview'
import waterfall from 'vue-waterfall2'
import VueConfig from './vue-config/index'

Vue.use(VueHammer)
Vue.use(VueCookie)
Vue.use(waterfall)
Vue.use(VueConfig)

Vue.component('Previewer', vuePicturePreview)

import VueTouch from 'vue-touch'
Vue.config.productionTip = false
Vue.prototype.$BUS = new Vue()

// 注册全局过滤器
import * as filters from './filters/filters'
Object.keys(filters).forEach((key: string) => {
  Vue.filter(key, (filters as any)[key])
})

Vue.directive('holdDown', {
  inserted(el: HTMLElement, binding) {
    const context = this
    let start = false, st: any = null, isHoldDown = false, startOffset= 0, isMove = false
    el.addEventListener('touchstart', (e: TouchEvent) => {
      isMove = false
      startOffset = e.touches[0].clientY
      if (start == false) {
        start = true
        isHoldDown = false
        st = setTimeout(() => {
          isHoldDown = true
          if (!isMove) binding.value.call(context, e, isHoldDown)
        }, 600)
      }
      e.stopPropagation()
    })
    el.addEventListener('touchmove', (e: TouchEvent) => {
      if (Math.abs(e.touches[0].clientY - startOffset) > 10) {
        isMove = true
      }
    })
    el.addEventListener('touchend', (e: TouchEvent) => {
      start = false
      isMove = false
      startOffset = 0
      clearTimeout(st)
      if (isHoldDown) {
        e.stopPropagation()
        e.preventDefault()
      } else {
        binding.value.call(context, e, isHoldDown)
      }
    })
  }
})

// 注册全局双击事件（@dblclick事件在移动端IOS是不支持的）
VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2,
})

//挂载原型
Vue.prototype.$toast = Toast
Vue.prototype.$messageBox = MessageBox
Vue.component(Popup.name, Popup)
Vue.use(VueTouch, { name: 'v-touch' })

Promise.polyfill()

new Vue({
  router,
  store,
  render: (h: any) => h(App),
}).$mount('#app')
